import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import StandardHeaderEmbed from './IDSHeaderEmbed'
import IDSSidebarEmbed from './IDSSidebarEmbed'
import IDSFooterEmbed from './IDSFooterEmbed'
import IDSSubHeaderEmbed from './IDSSubHeaderEmbed'

const scriptHeaderJson = document.getElementById('ids-header-json')
let headerParamObject = {}
if (scriptHeaderJson !== null) {
  headerParamObject = JSON.parse(scriptHeaderJson.textContent)
}

const scriptSubheaderJson = document.getElementById('ids-subheader-json')
let subheaderParamObject = {}
if (scriptSubheaderJson !== null) {
  subheaderParamObject = JSON.parse(scriptSubheaderJson.textContent)
}

const scriptSideJson = document.getElementById('ids-sidebar-json')
let sidebarParamObject = {}
if (scriptSideJson !== null) {
  sidebarParamObject = JSON.parse(scriptSideJson.textContent)
}

const scriptFooterJson = document.getElementById('ids-footer-json')
let footerParamObject = {}
if (scriptFooterJson !== null) {
  footerParamObject = JSON.parse(scriptFooterJson.textContent)
}

if (headerParamObject.flag === 'header') {
  const root = ReactDOM.createRoot(
    document.getElementById('standard-header-embed')
  )
  root.render(
    <React.StrictMode>
      <StandardHeaderEmbed
        hasProfileImage={headerParamObject.hasProfileImage}
        largeProfileImageUrl={headerParamObject.largeProfileImageUrl}
        name={headerParamObject.name}
        email={headerParamObject.email}
      />
    </React.StrictMode>
  )
}

if (subheaderParamObject.flag === 'subheader') {
  const root = ReactDOM.createRoot(
    document.getElementById('ids-subheader-embed')
  )
  root.render(
    <React.StrictMode>
      <IDSSubHeaderEmbed
        tenantsIncluded={subheaderParamObject.tenantsIncluded}
        headerBar={subheaderParamObject.headerBar}
        tenantName={subheaderParamObject.tenantName}
        image={subheaderParamObject.image}
      />
    </React.StrictMode>
  )
}

if (sidebarParamObject.flag === 'sidebar') {
  const root = ReactDOM.createRoot(document.getElementById('ids-sidebar-embed'))
  root.render(
    <React.StrictMode>
      <IDSSidebarEmbed
        data={sidebarParamObject.data}
        onToggleCollapsed={() => {}}
      />
    </React.StrictMode>
  )
}
if (footerParamObject.flag === 'footer') {
  const root = ReactDOM.createRoot(document.getElementById('ids-footer-embed'))
  root.render(
    <React.StrictMode>
      <IDSFooterEmbed
        productInfo={footerParamObject.productInfo}
        TenantZero={footerParamObject.TenantZero}
        supportLink={footerParamObject.supportLink}
        termsOfUseLink={footerParamObject.termsOfUseLink}
      />
    </React.StrictMode>
  )
}
